

import Model from './model.js';
import Payroll from './payroll.js';
import Employee from './employee.js';
import PayslipDetails from 'newCollections/payslip-details.js';
import Attachments from 'newCollections/attachments.js';
import moment from 'moment';
import config from 'config';
import axios from 'axios';

export default class Payslip extends Model {
    urlRoot() { return '/Payslips'; }

    constructor() {
        super(...arguments);
        this.employee = null;
        this.company = null;
        this.payroll = null;
    }

    initialize() {
        this.idAttribute = 'objectId';
        super.initialize(...arguments);
        this.details = new PayslipDetails(null, {payslip: this});
        this.attachments = new Attachments(null, {attachable: this});
        return this;
    }

    fetchPayroll() {
        if (this.payroll) {
            Promise.resolve(this.payroll);
        }

        return new Payroll({objectId: this.get('payrollId')})
            .fetch().then((payroll => {
                this.payroll = payroll;
                return this.payroll;
            }));
    }

    getPayroll() {
        return this.payroll;
    }

    setPayroll(payroll) {
        if (this.get('payrollId') === payroll.id) {
            this.payroll = payroll;
        }
    }

    fetchCompany() {
        if (this.company) {
            Promise.resolve(this.company);
        }

        return this.fetchPayroll()
            .then(payroll => payroll.fetchCompany())
            .then(company => {
                this.company = company;
                return this.company;
            });
    }

    getCompany() {
        return this.company;
    }

    setCompany(company) {
        if (this.payroll && this.payroll.get('companyId') === company.id) {
            this.company = company;
        }
    }

    getPeriod() {
        const payroll = this.getPayroll() || {};
        let m;

        if (this.get('periodDate')) {
            return moment(this.get('periodDate'));
        }

        if (typeof payroll.getPeriod === 'function') {
            return payroll.getPeriod();
        }

        m = moment(this.get('createdAt') || Date.now());
        if (m.date() >= config.periodStartDate) {
            return m;
        } else {
            return m.subtract(1, 'month');
        }
    }

    getPeriodFormatted() {
        const payroll = this.getPayroll() || {};

        if (typeof payroll.getPeriodFormatted === 'function') {
            return payroll.getPeriodFormatted();
        }

        return this.getPeriod().format('MMMM YYYY');
    }

    getFormattedDate() {
        return moment(this.get('createdAt')).format('MMM D, YYYY');
    }

    fetchDetails(limit = 30, pagination = true) {
        return new PayslipDetails(null, {payslip: this, filter: {
            limit: limit
        },
        pagination: pagination}).fetch().then((payslip) => { this.details = payslip; return this.details});
    }

    getDetails() {
        return this.details;
    }

    fetchEmployee() {
        if (this.employee) {
            Promise.resolve(this.employee);
        }

        if (!this.get('employeeId')) {
            return Promise.resolve(null);
        }

        return new Employee(
            {objectId: this.get('employeeId')}
        ).fetch({validate: false})
            .then(model => {
                this.employee = model;
                return this.employee;
            });
    }

    getEmployee() {
        return this.employee;
    }

    fetchAttachments() {
        return this.attachments.fetch().then(() => this.attachments);
    }

    getHrdf() {
        const hrdf = this.get('hrdf') || 0;
        const sum = this.getDetails()
            .filter(detail => {
                return detail.getPayrollItem().get('subtype') === 'hrdf';
            })
            .reduce((total, detail) => parseFloat(
                (detail.get('amount') + total).toFixed(2)
            ), hrdf);
        return sum || 0;
    }

    getPayslipJSON() {
        return axios.get(
            `${this.finalUrl()}/getJSON`, {
                headers: {'Authorization': app.user.getAccessToken().id}
            }
        ).then(r => r.data)
            .catch(err => {
                throw err.response.data.error;
            });
    }
}



// WEBPACK FOOTER //
// ./app/new-models/payslip.js